import classNames from 'classnames';
import React from 'react';
import { prefix, WebUI } from '../../wui-core/src';
import { ModalTitleProps } from './iModal';

const defaultProps = {
    componentClass: 'h4' as keyof JSX.IntrinsicElements,
    clsPrefix: `${prefix}-modal-title`
};

const ModalTitle: React.FC<ModalTitleProps> = (props) => {
    const {
        componentClass: Component = defaultProps.componentClass,
        className,
        clsPrefix = defaultProps.clsPrefix,
        ...restProps
    } = props;


    const classes: {[key: string]: boolean} = {};
    classes[`${clsPrefix}`] = true;

    return (
        <Component
            {...restProps}
            className={classNames(className, classes)}
        />
    );
}

export default WebUI({name: "modal-title", defaultProps})(ModalTitle) as React.FC<Partial<ModalTitleProps>>;
